<template>
  <v-col cols="12">
    <v-form ref="form">
      <base-card>
        <v-card-title>Facturas Electrónicas</v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              v-can="'Selector Compañias'"
              cols="12"
              sm="4"
            >
              <v-select
                ref="cliente"
                v-model="dataFilter.IdCompania"
                :items="filteredClients"
                item-text="text"
                item-value="IdCompania"
                label="Selecciona una compañía"
                prepend-inner-icon="mdi-sitemap"
                required
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-text-field
                          v-model="search"
                          placeholder="Buscar"
                          prepend-inner-icon="mdi-magnify"
                          hide-details
                          dense
                        />
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>

            <v-col
              cols="12"
              sm="4"
            >
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="dataFilter.dates"
                persistent
                width="290px"
              >
                <template v-slot:activator="{on, attrs}">
                  <v-text-field
                    v-model="dataFilter.dates"
                    label="Rango de fechas"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dataFilter.dates"
                  :range="!isGeneralAdmin"
                  :min="minDate"
                  :max="maxDate"
                  locale="es"
                >
                  <v-spacer />
                  <v-btn
                    text
                    style="background-color:rgb(204 33 40);color:white !important"
                    @click="modal = false"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    text
                    style="background-color:rgb(204 33 40);color:white !important"
                    @click="$refs.dialog.save(dataFilter.dates)"
                  >
                    Aceptar
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>

            <v-col
              cols="12"
              sm="4"
            >
              <v-select
                v-model="dataFilter.Status"
                :items="typeStatus"
                item-text="textStatus"
                item-value="valueStatus"
                label="Estado"
                prepend-inner-icon="mdi-order-bool-descending-variant"
                required
              />
            </v-col>

          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="dataFilter.Prefix"
                label="Prefijo (opcional)"
                prepend-inner-icon="mdi-file"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="dataFilter.Consecutivo"
                label="Consecutivo Factura (opcional)"
                prepend-inner-icon="mdi-note-multiple"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-btn
                class="ma-2"
                style="background-color:rgb(204 33 40);color:white !important"
                @click="searchInvoice"
              >
                Buscar
              </v-btn>
              <v-btn
                class="ma-2"
                color="GRAY"
                @click="clearForm"
              >
                Nueva Búsqueda
              </v-btn>
            </v-col>
            <v-row
              v-if="searchInvoiceProgress == true"
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-col cols="6">
                <v-col
                  class="text-subtitle-1 text-center"
                  cols="12"
                >
                  Consultando Facturas
                </v-col>
                <v-progress-linear
                  color="red darken-4"
                  indeterminate
                  rounded
                  height="6"
                />
              </v-col>
            </v-row>
            <v-col cols="12">
            <v-alert
              v-show="successAlert"
              :type="alertType"
              text
            >
              {{ msgSuccessAlert }}
            </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-alert
                v-if="notFoundInvoices"
                text
                type="info"
              >
                No se encontraron <strong>facturas</strong> para los filtros aplicados.
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>
      </base-card>
    </v-form>
  </v-col>
</template>

<script>
  import { listStatusFilters } from '@/data/listStatus'
  import { mapState } from 'vuex'
  import axios from 'axios'
  import { environment } from '@/data/environment'

  export default {
    name: 'FilterInvoices',
    data: () => ({
      notFoundInvoices: false,
      searchInvoiceProgress: false,
      hasSearched: false,
      modal: false,
      datepickerFinal: false,
      dateFinal: null,
      typeStatus: listStatusFilters,
      dataFilter: {
        IdCompania: null
      },
      msgSuccessAlert: '',
      successAlert: false,
      alertType: 'success',
      detailClients: [],
      search: '',
      userInfo: null,
      isGeneralAdmin: false

    }),
    created () {
      this.getUserInfo()
      this.obtenerCompanias()
    },
    computed: {
      ...mapState('invoice', ['listInvoice']),
      filteredClients() {
        const query = (this.search || '').toLowerCase()
        return this.detailClients.filter(c =>
          c.text.toLowerCase().includes(query)
        )
      },
      minDate() {
        const today = new Date()
        const sixtyDaysAgo = new Date(today)
        sixtyDaysAgo.setDate(today.getDate() - 60)
        return sixtyDaysAgo.toISOString().split('T')[0]
      },
      maxDate() {
        return new Date().toISOString().split('T')[0]
      },
    },
    watch: {
      listInvoice () {
        if (this.$store.state.invoice.listInvoice) {
          this.searchInvoiceProgress = false
          if (this.$store.state.invoice.listInvoice.length > 0) {
            this.notFoundInvoices = false
          } else if (this.$store.state.invoice.listInvoice.length == 0 && this.hasSearched) {
            this.notFoundInvoices = true
          }
        }
      },
    },
    methods: {
      generateAlertSuccess () {
        this.successAlert = true
        setTimeout(() => {
          this.successAlert = false
        }, 3000)
      },
      searchInvoice () {
        this.successAlert = false
        this.notFoundInvoices = false

        if (!this.isGeneralAdmin && !this.dataFilter.IdCompania) {
          this.alertType = 'error'
          this.msgSuccessAlert = 'Por favor selecciona una compañía'
          this.generateAlertSuccess()
          return
        }

        if (!this.dataFilter.dates || this.dataFilter.dates.length === 0) {
          this.alertType = 'error'
          this.msgSuccessAlert = 'Por favor selecciona una fecha'
          this.generateAlertSuccess()
          return
        }

        if (!this.dataFilter.Status) {
          this.alertType = 'error'
          this.msgSuccessAlert = 'Por favor selecciona un estado'
          this.generateAlertSuccess()
          return
        }

        this.hasSearched = true
        this.searchInvoiceProgress = true

        // Guardar el estado del filtro
        this.$store.commit('invoice/setCurrentFilterStatus', this.dataFilter.Status)

        // Guardar los parametros del filtro para poder refrescar
        this.$store.commit('invoice/setLastFilterParams', { ...this.dataFilter })

        this.$store.dispatch('invoice/getListInvoice', {
          ...this.dataFilter,
        })
      },
      clearForm () {
        this.$refs.form.reset()
        this.search = ''
        this.hasSearched = false
        this.notFoundInvoices = false
        this.$store.commit('invoice/setListInvoice', [])
        this.$store.commit('invoice/setCurrentFilterStatus', '')
        this.$store.commit('invoice/setSelectedInvoices', [])
        this.$store.commit('invoice/setLastFilterParams', null)
      },
      getUserInfo() {
        try {
          const uid = localStorage.getItem('uid')
          if (uid) {
            this.userInfo = JSON.parse(atob(uid))
            const rol = JSON.parse(localStorage.getItem('role') || "[]")
            this.isGeneralAdmin = rol.includes('General-Admin') || rol.includes('General')
            if (this.isGeneralAdmin) {
              this.dataFilter.IdCompania = this.userInfo.idcompania
            }
          }
        } catch (error) {
          console.error('Error al obtener información del usuario:', error)
        }
      },
      async obtenerCompanias() {
        if (this.isGeneralAdmin) {
          return
        }
        
        try {
          const response = await axios.get(environment.HIOPOSWEBSERVICES + '/getClientsForXML')
          
          let companies = response.data.Mensaje
          
          this.detailClients = companies.map(c => ({
            text: " [ " + c.id +  " ] " +  c.name,
            IdCompania: c.id,
          }))
        } catch (error) {
          console.error('Error al obtener compañías:', error)
        }
      },
    },
  }
</script>

<style scoped>

</style>
